// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FATUr{padding-top:0}._1MfuM{display:inline-block;float:right}._1wKWH{-webkit-transform:translateX(-50%) translateY(-50%) rotate(-60deg);-ms-transform:translateX(-50%) translateY(-50%) rotate(-60deg);transform:translateX(-50%) translateY(-50%) rotate(-60deg);left:50%;top:45%;position:absolute;cursor:pointer;color:#666}._1wKWH:hover{color:#000}._1Pqxp{cursor:pointer;color:#666}._1Pqxp:hover{color:#000}._23wCH:hover{cursor:pointer}.qO1jy{border:0}", ""]);
// Exports
exports.locals = {
	"root": "FATUr",
	"button": "_1MfuM",
	"geneHeader": "_1wKWH",
	"header": "_1Pqxp",
	"cell": "_23wCH",
	"row": "qO1jy"
};
module.exports = exports;
